import Vue from "vue";
import Router from "vue-router";
import Main from "@/components/Main";
import PrintServerCreate from "@/components/printers/PrintServerCreate";
import PrinterEdit from "@/components/printers/PrinterEdit";
import CatalogueEdit from "@/components/printers/CatalogueEdit";
import PrintGroupEdit from "@/components/printers/PrintGroupEdit";
import config from "@/vue.config";
import { OktaAuth } from "@okta/okta-auth-js";
import OktaVue from "@okta/okta-vue";
import { LoginCallback } from "@okta/okta-vue";

Vue.use(Router);

const oktaAuth = new OktaAuth({
  issuer: config.auth.issuer,
  clientId: config.auth.clientId,
  redirectUri: window.location.origin + "/login/callback",
  scopes: ["openid", "profile", "email"],
});
Vue.use(OktaVue, { oktaAuth });

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "home",
      component: Main,
      meta: {
        requiresAuth: true,
      },
    },
    { path: "/login/callback", component: LoginCallback },

    // Printers API
    {
      path: "/printers/print_server",
      name: "CreatePrintServer",
      component: PrintServerCreate,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/printers/print_server/:id/edit",
      name: "EditPrintServer",
      component: PrintServerCreate,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/printers/printers/:id/edit",
      name: "EditPrinter",
      component: PrinterEdit,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/printers/catalogues/:id/edit",
      name: "EditCatalogue",
      component: CatalogueEdit,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/printers/print_groups/:id/edit",
      name: "EditPrintGroup",
      component: PrintGroupEdit,
      meta: {
        requiresAuth: true,
      },
    },
  ],
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js